import { useUserSubscriptions } from "./useUserSubscriptions";

export const useCurrentSubscription = () => {
  const { subscriptions } = useUserSubscriptions();
  const currentSubscription = subscriptions?.[0];

  return currentSubscription;
};
